import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import App from "./App.js";
import { domainConfig } from "./config.js";
import moment from 'moment';
import 'moment/locale/pt-br';
import "./assets/scss/light.scss";
import "react-image-gallery/styles/css/image-gallery.css";
import "yet-another-react-lightbox/styles.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-datetime/css/react-datetime.css";
import * as serviceWorkerRegistration from './serviceWorkerRegistration.js';
import { installClientObservability } from './utils/observability.js';

// Set moment locale to Portuguese
moment.locale('pt-br');

axios.defaults.baseURL = domainConfig.restAPI
axios.defaults.withCredentials = true;
axios.defaults.headers.common['x-api-key'] = process.env.REACT_APP_SECRET_API_KEY
installClientObservability({
  axios,
  apiBaseUrl: domainConfig.restAPI,
  apiKey: process.env.REACT_APP_SECRET_API_KEY,
});

let isRefreshing = false;
if ('serviceWorker' in navigator) {
  const hadController = Boolean(navigator.serviceWorker.controller);
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hadController && !isRefreshing) {
      isRefreshing = true;
      window.location.reload();
    }
  });
}

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log('New SW waiting:', registration.waiting);
  },
});
